module.exports = __webpack_public_path__ + "static/media/iconoScoreGrisTick.ce62b619.svg";